const RED_NAV_SURFACE_CLASS =
  "!bg-red-900/[0.10] hover:!bg-red-900/[0.16] " +
  "group-hover/sidenav-hit:!bg-red-900/[0.16] " +
  "group-focus-within/sidenav-hit:!bg-red-900/[0.16] " +
  "dark:!bg-red-900 dark:!bg-opacity-20 dark:hover:!bg-red-900 dark:hover:!bg-opacity-30 " +
  "dark:group-hover/sidenav-hit:!bg-red-900 dark:group-hover/sidenav-hit:!bg-opacity-30 " +
  "dark:group-focus-within/sidenav-hit:!bg-red-900 dark:group-focus-within/sidenav-hit:!bg-opacity-30";

const RED_NAV_SURFACE_HOVER_CLASS = "!bg-red-900/[0.16] dark:!bg-red-900 dark:!bg-opacity-30";

const RED_NAV_SURFACE_STABLE_CLASS =
  "!bg-red-900/[0.10] hover:!bg-red-900/[0.10] " +
  "group-hover/sidenav-hit:!bg-red-900/[0.10] " +
  "group-focus-within/sidenav-hit:!bg-red-900/[0.10] " +
  "dark:!bg-red-900 dark:!bg-opacity-20 dark:hover:!bg-red-900 dark:hover:!bg-opacity-20 " +
  "dark:group-hover/sidenav-hit:!bg-red-900 dark:group-hover/sidenav-hit:!bg-opacity-20 " +
  "dark:group-focus-within/sidenav-hit:!bg-red-900 dark:group-focus-within/sidenav-hit:!bg-opacity-20";

/**
 * Marker class for the "chalk employees only" red treatment. When demo mode is active
 * (`chalk-demo-mode` on the root element), styles/admin-demo-mode.css uses this marker to
 * suppress the red backgrounds on static containers while the admin-only components stay
 * visible. Demo mode hides ALL red: interactive nav surfaces gate both the admin and the
 * danger classes on useRedSurfacesSuppressed instead (the CSS route would also erase
 * their hover/active highlights), which is why the danger surfaces below carry no marker.
 */
const CHALK_ADMIN_SURFACE_MARKER_CLASS = "chalk-admin-surface";

export const CHALK_ADMIN_SURFACE_CLASS = `${CHALK_ADMIN_SURFACE_MARKER_CLASS} ${RED_NAV_SURFACE_CLASS}`;

export const CHALK_ADMIN_SURFACE_HOVER_CLASS = `${CHALK_ADMIN_SURFACE_MARKER_CLASS} ${RED_NAV_SURFACE_HOVER_CLASS}`;

export const CHALK_ADMIN_SURFACE_STABLE_CLASS = `${CHALK_ADMIN_SURFACE_MARKER_CLASS} ${RED_NAV_SURFACE_STABLE_CLASS}`;

export const CHALK_DANGER_SURFACE_CLASS = RED_NAV_SURFACE_CLASS;

export const CHALK_DANGER_SURFACE_STABLE_CLASS = RED_NAV_SURFACE_STABLE_CLASS;

export const CHALK_DANGER_SURFACE_HOVER_CLASS = RED_NAV_SURFACE_HOVER_CLASS;
